// extracted by mini-css-extract-plugin
export default {"socialMedia":"SocialMedia_socialMedia__fgAST","icon":"SocialMedia_icon__95bRD"};